import {
    TbBrandPython,
    TbCodeDots,
    TbFile,
    TbFileTypeCsv,
    TbFileTypeDoc,
    TbFileTypeDocx,
    TbFileTypeJpg,
    TbFileTypePdf,
    TbFileTypePng,
    TbFileTypePpt,
    TbFileTypeSvg,
    TbFileTypeTxt,
    TbFileTypeXls,
    TbVideo,
} from 'react-icons/tb';

import { MIME_TYPES } from '@mantine/dropzone';

const icons: {
    [key: string]: any;
} = {
    [MIME_TYPES.csv]: TbFileTypeCsv,
    [MIME_TYPES.jpeg]: TbFileTypeJpg,
    [MIME_TYPES.mp4]: TbVideo,
    [MIME_TYPES.pdf]: TbFileTypePdf,
    [MIME_TYPES.png]: TbFileTypePng,
    [MIME_TYPES.svg]: TbFileTypeSvg,
    [MIME_TYPES.xls]: TbFileTypeXls,
    [MIME_TYPES.xlsx]: TbFileTypeXls,
    [MIME_TYPES.doc]: TbFileTypeDoc,
    [MIME_TYPES.docx]: TbFileTypeDocx,
    [MIME_TYPES.ppt]: TbFileTypePpt,
    [MIME_TYPES.pptx]: TbFileTypePpt,
    'text/plain': TbFileTypeTxt,
    'video/quicktime': TbVideo,
    'video/webm': TbVideo,
    'application/json': TbCodeDots,
    'text/python': TbBrandPython,
    'text/x-python': TbBrandPython,
};

const getFileIcon = (mimeType: string) => {
    return icons[mimeType] || TbFile;
};

const FileIcon = ({ mimeType, ...props }: { mimeType: string } & any) => {
    const Icon = getFileIcon(mimeType);

    return <Icon strokeWidth={1.5} {...props} />;
};

export { FileIcon, getFileIcon };
